import React from "react";
import MaskedInput from "react-text-mask";

const MobileMaskedInput = ({
    name = "mobileNo",
    id = "mobileNo",
    label = "Mobile Number",
    value = "",
    onChange,
    onBlur,
    error = "",
    touched = false,
    placeholder = "Enter 10-digit mobile number",
    className = "",
    disabled = false,
    readOnly = false,
    maxLength = 10,
    ...rest
}) => {
    return (
        <div className={`input-wrap Trav-fm ${className}`}>
            <MaskedInput
                className={`textdemo ${error && touched ? "border-red-500" : ""}`}
                mask={[
                    /[6-9]/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                ]}
                guide={false}
                showMask={false}
                type="text"
                id={id}
                name={name}
                value={value}
                placeholder=" "
                maxLength={maxLength}
                autoComplete="off"
                disabled={disabled}
                readOnly={readOnly}
                onChange={onChange}
                onBlur={onBlur}
                {...rest}
            />
            <label className="demo-label">{label}</label>
            {error && touched && (
                <div className="error-message text-red-600 text-sm mt-1">{error}</div>
            )}
        </div>
    );
};

export default MobileMaskedInput;
